import { render } from "./MaintenanceRequest.vue?vue&type=template&id=353fafbe"
import script from "./MaintenanceRequest.vue?vue&type=script&lang=js"
export * from "./MaintenanceRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__